import React from "react";
import {
  Checkbox as MuiCheckbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  type CheckboxProps as MuiCheckboxProps,
} from "@mui/material";

interface CheckboxProps extends Omit<MuiCheckboxProps, "checked" | "onChange"> {
  field: {
    value: boolean;
    onChange: (value: boolean) => void;
    onBlur?: () => void;
    name?: string;
    ref?: React.Ref<any>;
  };
  label?: string;
  error?: boolean;
  helperText?: string;
  sx?:any;
}

const Checkbox: React.FC<CheckboxProps> = ({
  field,
  label,
  error = false,
  helperText,
  sx,
  ...rest
}) => {
  return (
    <FormControl error={error}sx={sx}>
      <FormControlLabel
        control={
          <MuiCheckbox
            {...rest}
            name={field.name ?? ""}
            checked={!!field.value}
            onChange={(e) => field.onChange(e.target.checked)}
            onBlur={field.onBlur}
            {...(field.ref ? { inputRef: field.ref } : {})}
          />
        }
        label={label}
      />

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default Checkbox;